var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{class:[
    'v-hero',
    {
      'v-hero--with-image': !!_vm.imgSrc,
      'v-hero--extra-blur': !!_vm.imgSrc && _vm.blur,
      'v-hero--auto-height': !!_vm.autoHeight,
      'v-hero--small': !!_vm.small,
      'v-hero--minimal': !!_vm.minimal,
      'v-hero--split': !!_vm.split
    }
  ]},[(_vm.minimal)?_c('div',{staticClass:"v-hero__content container-fluid"},[_vm._t("default")],2):(_vm.split && !_vm.video)?_c('div',{staticClass:"v-hero__container--image"},[_c('div',{staticClass:"v-hero--split__media",style:([
        !!_vm.imgSrc && { backgroundImage: `url('${_vm.resolveUrl(_vm.imgSrc)}')` }
      ])}),_c('div',{staticClass:"v-hero--split__content"},[_vm._t("default")],2)]):(_vm.split && _vm.video)?_c('div',{staticClass:"container-fluid"},[_vm._t("default")],2):_c('div',{staticClass:"v-hero__image",style:([
      !!_vm.imgSrc && { backgroundImage: `url('${_vm.resolveUrl(_vm.imgSrc)}')` },
      !!_vm.imgAlign && { backgroundPosition: _vm.imgAlign },
      (!!_vm.imgMdSrc || !!_vm.imgSrc) && {
        '--hero-image-large': `url('${_vm.resolveUrl(_vm.imgMdSrc || _vm.imgSrc)}')`
      }
    ])},[(_vm.hasContent)?_c('div',{staticClass:"v-hero__content container-fluid"},[_vm._t("default")],2):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }